import { useState, useCallback, useEffect } from 'react'

export enum SessionStorageKey {
  KNOWLEDGEBANK_FILTER = 'knowledgebank_filter',
}

type ObjectType = { [key: string]: string | number | boolean }

export type SessionStorageValue = string | number | boolean | null | ObjectType

export const useSessionStorage = <T extends SessionStorageValue>(key: SessionStorageKey, initialValue?: T) => {
  const readValue = useCallback((): T | null => {
    const item = sessionStorage.getItem(key)
    if (item !== null) {
      return JSON.parse(item)
    }
    return initialValue ?? null
  }, [key, initialValue])

  const [storedValue, setStoredValue] = useState<T | null>(readValue)

  useEffect(() => {
    setStoredValue(readValue())
  }, [readValue])

  const setValue = useCallback(
    (value: T) => {
      setStoredValue(value)
      sessionStorage.setItem(key, JSON.stringify(value))
    },
    [key]
  )

  return [storedValue, setValue] as const
}
